const styles = ({ COLORS }) => ({
  link: {
    margin: '0 14px',
    paddingBottom: '16px',
    fontSize: '20px',
    position: 'relative',
    '& > a': {
      textDecoration: 'none',
      color: '#777',
      transition: 'color 0.3s ease-in-out'
    },
    '&:hover > a': {
      color: COLORS.BLUE.NORMAL
    },
    '&:after': {
      left: 0,
      width: '100%',
      height: '2px',
      bottom: 0,
      content: '""',
      position: 'absolute',
      transform: 'scaleX(0)',
      transition: 'transform 0.3s ease-in-out',
      backgroundColor: 'rgba(0,175,236,1)'
    }
  },
  activeLink: {
    '& > a': {
      color: COLORS.BLUE.NORMAL
    },
    '&:after': {
      transform: 'scaleX(1)'
    }
  }
})

export default styles
